<script>
  import { getPath } from '../../utils/imageKit.ts';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let { dataTestId = 'drug-images-tile-image', details, url, lazyloadImage } = $props();

  const defaultImageUrl = getPath(details.image, { w: 178, h: 134, bg: '#000000', fo: 'bottom' });
  const highResImageUrl = getPath(details.image, { w: 178, h: 134, bg: '#000000', fo: 'bottom' }, 2);
</script>

<BaseLink
  className="p-4 bg-white w-53 mb-4 rounded-lg group relative shadow-y-sm pseudo-shadow-tight-hover border border-gray-light-silver active:shadow-active"
  {dataTestId}
  {url}
>
  <figure>
    <img
      class="mb-2"
      loading={lazyloadImage === true ? 'lazy' : 'eager'}
      width="178"
      height="134"
      src={defaultImageUrl}
      alt={details.image.alt}
      srcset={`${defaultImageUrl}, ${highResImageUrl} 2x`}
      sizes="178px"
    />
    <figcaption class="mt-4 text-sm xl:text-base leading-tight font-medium text-gray-charcoal text-center">
      {details.form}, {details.label}
    </figcaption>
  </figure>
</BaseLink>
